import { get, put, post } from 'Api';
import store, { history } from 'Redux/store';
import { toggleGiftModal, toggleRedeemRequestModal } from 'Redux/ducks/modal';
import { toggleFeedbackPopup } from 'Redux/ducks/feedback-popups';
import { getAtok } from 'Api/Order/key-reveal-service';
import { setReturnMethod } from 'Redux/ducks/atok';

const SET_GIFT_ORDER_DATA = 'frontend/checkout/SET_GIFT_ORDER_DATA';

export async function getGift(code) {
  let gift = {};
  try {
    const language = window.locale || 'en';
    const { response, data } = await get([], `/orders/get-gift/${code}/${language}`);
    if (response.ok) {
      gift = data;
    }
  } catch (ex) {
    store.dispatch(toggleFeedbackPopup({ type: 'error', title: 'Gift Error', message: 'Something went wrong fetching the gift. Please try again or contact support.' }));
  }

  return gift;
}

export async function acceptGift(code) {
  try {
    const { response, data } = await put([], `/user/orders/accept-gift/${code}`);
    if (response.ok) {
      history.push(`/orders/${data._id}`);
    } else {
      window.location.reload(true);
    }
  } catch (ex) {
    store.dispatch(toggleFeedbackPopup({ type: 'error', title: 'Gift Error', message: 'Something went wrong accepting the gift. Please try again or contact support.' }));
  }
}

export async function revokeGift(orderId) {
  try {
    const { response } = await put([], `/user/orders/revoke-gift/${orderId}`);
    if (response.ok) {
      window.location.reload(true);
    }
  } catch (ex) {
    store.dispatch(toggleFeedbackPopup({ type: 'error', title: 'Gift Error', message: 'Something went wrong revoking the gift. Please try again or contact support.' }));
  }
}

export async function convertToGiftAtokCheck(orderId) {
  try {
    const { response, data } = await post([], `/user/orders/atok-check/${orderId}`, { atok: getAtok() });

    if (data.validAtock && response.ok) {
      // following revealkey where setreturnmethod is set the function that calls it
      setReturnMethod(convertToGiftAtokCheck);
      store.dispatch(toggleGiftModal({ giftOrder: {}, orderId, giftAction: 'convert' }));
    } else {
      store.dispatch(toggleRedeemRequestModal());
    }
  } catch (ex) {
    store.dispatch(toggleFeedbackPopup({ type: 'error', title: 'Gift Error', message: 'Something went wrong converting the order to a gift. Please try again or contact support.' }));
  }
}

export async function convertToGift(orderId, giftOrder) {
  try {
    const { response, data } = await put([], `/user/orders/convert-to-gift/${orderId}`, { ...giftOrder, atok: getAtok() });
    if (response.ok) {
      window.location.reload(true);
    } else if (response.status === 400 && data?.message) {
      store.dispatch(toggleFeedbackPopup({ type: 'error', title: 'Gift Error', message: data.message }));
    }
  } catch (ex) {
    store.dispatch(toggleFeedbackPopup({ type: 'error', title: 'Gift Error', message: 'Something went wrong converting your order to a gift. Please try again or contact support.' }));
  }
}

export async function editGift(orderId, giftOrder) {
  try {
    const { response, data } = await put([], `/user/orders/edit-gift/${orderId}`, giftOrder);
    if (response.ok) {
      window.location.reload(true);
    } else if (response.status === 400 && data?.message) {
      store.dispatch(toggleFeedbackPopup({ type: 'error', title: 'Gift Error', message: data.message }));
    }
  } catch (ex) {
    store.dispatch(toggleFeedbackPopup({ type: 'error', title: 'Gift Error', message: 'Something went wrong editing your gift. Please try again or contact support.' }));
  }
}

export function setGiftOrder(data) {
  store.dispatch({ type: SET_GIFT_ORDER_DATA, payload: data });
}
